<template>
  <div class="reviews">
    <div class="container">
      <div class="reviews-trustpilot" :class="[dark ? 'dark' : '']">
        <div class="reviews-heading" :class="[uniqueClass]">
          <div v-if="title">
            <h2 class="h2 heading title" :class="titleClass" v-html="title" />
          </div>
          <div v-else>
            <h2 class="h2 heading">
              4.9/5
            </h2>
            <div v-if="ratedText">
              {{ ratedText }}
            </div>
            <div v-else>
              Rated as Excellent on
              <IconTrustPilot />
            </div>
          </div>
        </div>
        <div class="reviews-body" :class="{ 'show': seeMore, 'short': short }">
          <div class="reviews-body-holder row">
            <div v-for="(group, idx) in dataStructure()" :key="idx" class="col col-4">
              <div
                v-for="(review, i) in group" :key="i" class="card-trustpilot-review"
              >
                <div class="heading">
                  <img loading="lazy" :src="`${$config.imagesUrl}/reviews/${review.image}`" :alt="review.name">  {{ review.name }}
                </div>
                <div class="rating">
                  <div
                    v-for="id in 5" :key="id" class="rating-star-wrapper"
                    :class="{ 'light': review.rating < 5, 'filled': id <= review.rating }"
                  >
                    <IconTrustPilotStar />
                  </div>
                </div>
                <div v-if="review.title" class="title">
                  {{ review.title }}
                </div>
                <div class="text">
                  {{ review.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="see-more" :class="{ 'expanded': seeMore }">
          <div @click.prevent="expandReviews">
            <span v-if="seeMore">See Less <IconArrowDown /></span>
            <span v-else class="expand">See More <IconArrowDown /></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTrustPilot from '../../assets/svg/icon-trustpilot.svg?vue-component';
import IconTrustPilotStar from '../../assets/svg/icon-trustpilot-star.svg?vue-components';
import IconArrowDown from '../../assets/svg/icon-expand.svg?vue-component';

export default {
  components: {
    IconTrustPilot,
    IconTrustPilotStar,
    IconArrowDown,
  },
  props: {
    reviewsData: { type: Array, default: () => [], required: false },
    dark: Boolean,
    short: Boolean,
    title: { type: String, default: '', required: false },
    titleClass: { type: String, default: '', required: false },
    uniqueClass: { type: String, default: '', required: false },
    ratedText: { type: String, default: '', required: false },
  },
  data() {
    return {
      seeMore: false,
    };
  },
  methods: {
    reviews() {
      if (this.short && this.$config.platform === 'ds') {
        return [
          {
            title: 'I am a beginner in programming and have...',
            text: 'I am a beginner in programming and have used 365 Data Science and, speaking for myself, the progress I have made so far is incredible. I can now code ML related stuff. Unthinkable for a guy with no background in computer science. Kudos to the 365 team! Keep them coming, lads!',
            name: 'Nabil Mahamad Hanif',
            country: 'India',
            rating: 5,
            image: 'Nabil Mahamad Hanif.jpg',
          },
          {
            title: '365 Data Science',
            text: 'I recommend this program to anyone since it is a single platform that teaches everything in a logical order without losing your attention and interest. This program covers the skills related to each step - data collection, analysis & modeling, as well as reporting. The topics are explained in such a way that you look forward to the next one. You will see great improvement in a short time.',
            name: 'Shovkat',
            rating: 5,
            country: 'Turkey',
            image: 'Shovkat.jpg',
          },
          {
            title: 'Best Platform for Data Science',
            text: "So, I was searching for quality, well-organized contents for Data Science. After looking at many sites, I finally ended up on the 365 Data Science website. Guys, believe me, I have never seen any course build-up this well-organized. I'm totally grateful and thankful to the 365 team. It's helping me become a Data Scientist and I'm loving it. Enroll in any of their courses, you won't regret it.",
            name: 'Ahmad Zakaria',
            country: 'Germany',
            rating: 5,
            image: 'Ahmad Zakaria.jpg',
          },
          {
            title: 'It is well-presented and well-prepared...',
            text: 'The materials are well-presented and well-prepared. Very good learning programs, highly recommended for those who want to study a subject in data analysis/science. I have subscribed to the website and it is worth every cent.',
            name: 'Anton',
            country: 'Russia',
            rating: 5,
            image: 'Anton.jpg',
          },
          {
            title: 'Bundle of Joy',
            text: 'I was looking for a complete package for learning Data Science from scratch to an advanced level, but had not found any suitable one. In my quarantine days, while googling, I found this tremendous bundle of Data Science courses where the course curriculum and the contents amazed me. Thank you, 365 Team, for making such organized and beautiful course contents for us.',
            name: 'Monira Akter Laboni',
            country: 'India',
            rating: 5,
            image: 'Monira Akter Laboni.jpg',
          },
          {
            title: 'Quality Content',
            text: 'The 365 Data Science course is outstanding, it has an outstanding interface and awesome courses from a basic to an advanced level. I really appreciate the quality of the material and the content of this Data Science course!! Thanks to the 365 Data Science team!',
            name: 'Rakesh Patel',
            country: 'United States',
            rating: 5,
            image: 'Rakesh Patel.jpg',
          },
        ];
      }
      if (this.short && this.$config.platform === 'fa') {
        return [
          {
            text: 'Great course. This course has helped me a lot in gaining knowledge in finance, accounting, business analysis, advanced MS excel, and PowerPoint. Highly recommended.',
            name: 'Snehadri N.',
            country: 'Myanmar',
            rating: 4,
            image: 'sn.jpg',
          },
          {
            text: 'Wow! This is exactly the kind of information I am looking for! Very detailed (which is very helpful!), engaging, polished, all-in-all makes for an amazing learning experience!',
            name: 'Juanita O.',
            country: 'Mexico',
            rating: 5,
            image: 'sm_juanita_o.jpg',
          },
          {
            text: 'Just a week into the training and learnt some new formulas in excel which I didn’t know existed until now. I am enjoying the accounting and financial modelling part. Overall the learning experience has been amazing..',
            name: 'Mohammed A.',
            country: 'Saudi Arabia',
            rating: 5,
            image: 'sm_mohammed_a.jpg',
          },
          {
            text: 'This is an amazing Course! Really helped me a lot. Learnt a lot of new things, using Excel like never before. Its a complete package of being interesting, keeping the person motivated and curious about what will come next, and being fun at the same time.',
            name: 'Sachin H.',
            country: 'Morocco',
            rating: 4,
            image: 'sm_sachin_h.jpg',
          },
          {
            text: 'I am new to finance, and this course gave me a wide variety of knowledge about many financial concepts out there. I recommend this course to everyone as anyone can follow along without prior knowledge.',
            name: 'Akshat J.',
            country: 'Egypt',
            rating: 5,
            image: 'sm_akshat-j.jpg',
          },
          {
            text: 'Amazing Course! The material is presented in a very easy to follow manner and is very detailed. Best Course out here for learning EXCEL skills in order to be a master financial analyst, and definitely worth the price!',
            name: 'Felicia W.',
            country: 'Germany',
            rating: 5,
            image: 'sm_felicia_w.jpg',
          },
        ];
      }
      if (!this.short && this.$config.platform === 'ds') {
        return [
          {
            title: '365 Data Science Program is mind…',
            text: "The 365 Data Science Program is mind-blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science. The stuff they explain in the intro course is a great source of information. You don't want to miss this one.",
            name: 'Vikesh Reddy Nallamilli',
            country: 'India',
            rating: 5,
            image: 'Vikesh Reddy Nallamilli.jpg',
          },
          {
            title: '365 Data Science is one of the best…',
            text: '365 Data Science is one of the best resources to learn the concepts and tools to become an aspiring data scientist. I would recommend it to any beginner.',
            name: 'Maher Nabeel',
            country: 'United Arab Emirates',
            rating: 5,
            image: 'Maher Nabeel.jpg',
          },
          {
            title: 'The 365 Data Science program is great...',
            text: 'The 365 Data Science program is great for beginners. It gives in-depth knowledge and clears every concept. After every lecture, some exercises are given for students to complete for practice, and solutions also. I would highly recommend this program to everyone who wants to be a data scientist and brush up their skills.',
            name: 'harshita sharma',
            country: 'Pakistan',
            rating: 5,
            image: 'harshita sharma.jpg',
          },
          {
            title: 'For a busy professional like myself',
            text: 'For a busy professional like myself, I usually don’t have time to read books. 365 Data Science seemed to spend a lot of time tailoring videos that can easily be followed... Videos are short and concise, but very informative.',
            name: 'Mounir',
            country: 'Pakistan',
            rating: 5,
            image: 'Mounir.jpg',
          },
          {
            title: 'Perfect and complete course for data science',
            text: '365 Data Science is really a complete package for the ones who love learning data science. In the course, you can learn data science from scratch, being taught easily and comprehensibly.',
            name: 'Ali Javid',
            country: 'Iran',
            rating: 4,
            image: 'Ali Javid.jpg',
          },
          {
            title: 'Incredible learning program',
            text: 'I found this program to be very well structured. You have everything you need to start in the data science field, very well explained and with excellent exercises for one to practice. You will not only not get bored at all, but you will also learn a huge load of stuff. Fully recommended.',
            name: 'Rodrigo Mendizabal',
            country: 'Spain',
            rating: 5,
            image: 'Rodrigo Mendizabal.jpg',
          },
          {
            title: 'The 365 Data Science program is the Best!!!',
            text: 'The 365 Data Science program was excellent. It does meet my expectations 100%. I do thank the 365 Data Science Team for putting this great work together in one package & with a very reasonable price. Hands down, you are the best! Please, keep this great work up!',
            name: 'Amrouni',
            country: 'France',
            rating: 5,
            image: 'Amrouni.jpg',
          },
          {
            title: 'Excellent experience',
            text: 'Excellent courses, excellent instructors, and overall a great experience. I learned a great deal from these courses.',
            name: 'Klodian Xhini',
            country: 'United Kingdom',
            rating: 5,
            image: 'Klodian Xhini.jpg',
          },
          {
            title: '365 Data Science Review Program…',
            text: 'I just completed the first course in the 365 Data Science Program. I must say, it’s an excellent course with great insight and well-structured infographic, putting all concept at a glance. I can’t wait to get through other courses and modules of the program.',
            name: 'Ndubuisi Nwabueze',
            country: 'Nigerian',
            rating: 5,
            image: 'Ndubuisi Nwabueze.jpg',
          },
          {
            title: 'Best MOOC platform to learn Data Science',
            text: "365 Data Science is an amazing platform and I would recommend it to everyone who wish to start his/her journey in Data Science field. You don't need any prerequisites, you only need good internet connection and curiosity. I needed the right platform for Data Science, a platform that is equipped with all quality resources needed, all at one place, with a good tutor. I found every such quality in 365 Data Science. They also provide certificates and notes.",
            name: 'anuj gupta',
            country: 'India',
            rating: 5,
            image: 'anuj gupta.jpg',
          },
          {
            title: 'Worth every penny!',
            text: 'Worth every penny! I knew barely anything about data science before this course, and now I am confident in my skills. There are many sections on different topics - from the very basics to advanced things. By the time of completion, I am confident in my skills and recommend it to everyone!',
            name: 'Stas Popov',
            country: 'Russia',
            rating: 5,
            image: 'Stas Popov.jpg',
          },
          {
            title: 'I FOUND A TREASURE DURING COVID',
            text: 'This course stands out as Excellent. As an HR Professional who wants to major in Analytics, I found the learning experience so exciting. The instructor made learning fun! I will recommend this to everyone out there.',
            name: 'Oyesina Victor Akingboye',
            country: 'France',
            rating: 5,
            image: 'Oyesina Victor Akingboye.jpg',
          },
          {
            title: 'The best Data Science courses out there !!',
            text: '365 Data Science gives the best data science courses out there! It’s really helpful, the videos come with exercise files and quizzes to test your skills at each module, to determine your level. You can learn at your own pace. Also, the Q&A section is really helpful and they give you an answer quickly!',
            name: 'Amin Bt',
            country: 'Turkey',
            rating: 5,
            image: 'Amin Bt.jpg',
          },
          {
            title: 'Best Data Science Online Platform !!',
            text: 'The best Data Science online platform, with lots of useful and valuable topics. Highly Recommended for Everyone!!!',
            name: 'Davit Bolkvadze',
            country: 'Georgian',
            rating: 5,
            image: 'Davit Bolkvadze.jpg',
          },
          {
            title: 'Amazing experience',
            text: 'To be honest, 365 Data Science is one of the best platforms where you can explore and learn a lot. It is a place where you will gain a lot of knowledge and will also understand each and everything explained in the course. Plus, there are lots of quizzes and exercises which help you to excel in the course, and also to check for mistakes and correct them.',
            name: 'Priya Pandey',
            country: 'India',
            rating: 5,
            image: 'Priya Pandey.jpg',
          },
        ];
      }
      return [
        {
          text: 'Wow! This is exactly the kind of information I am looking for! Very detailed (which is very helpful!), engaging, polished, all-in-all makes for an amazing learning experience!',
          name: 'Juanita O.',
          country: 'Mexico',
          rating: 5,
          image: 'sm_juanita_o.jpg',
        },
        {
          text: 'Just a week into the training and learnt some new formulas in excel which I didn’t know existed until now. I am enjoying the accounting and financial modelling part. Overall the learning experience has been amazing..',
          name: 'Mohammed A.',
          country: 'Saudi Arabia',
          rating: 5,
          image: 'sm_mohammed_a.jpg',
        },
        {
          text: 'I am new to finance, and this course gave me a wide variety of knowledge about many financial concepts out there. I recommend this course to everyone as anyone can follow along without prior knowledge.',
          name: 'Akshat J.',
          country: 'Egypt',
          rating: 5,
          image: 'sm_akshat-j.jpg',
        },
        {
          text: 'Amazing Course! The material is presented in a very easy to follow manner and is very detailed. Best Course out here for learning EXCEL skills in order to be a master financial analyst, and definitely worth the price!',
          name: 'Felicia W.',
          country: 'Germany',
          rating: 5,
          image: 'sm_felicia_w.jpg',
        },
        {
          text: 'This is an amazing Course! Really helped me a lot. Learnt a lot of new things, using Excel like never before. Its a complete package of being interesting, keeping the person motivated and curious about what will come next, and being fun at the same time.',
          name: 'Sachin H.',
          country: 'Morocco',
          rating: 4,
          image: 'sm_sachin_h.jpg',
        },
        {
          text: 'My experience with this course has been really good. The course content was up to the mark. Multiple exercises were provided to get a grasp on Excel functions. I had a couple of doubts and got prompt replies from the instructor which helped me a lot. Overall, a great learning experience.',
          name: 'Poorva B.',
          country: 'India',
          rating: 4,
          image: 'pb.jpg',
        },
        {
          text: 'It has really helped me gain more knowledge on finances. It’s one of my best decision to take on this course, MUST TRY.....I do recommend it to check it out, it’s definitely going to help you out in the long run.',
          name: 'Ashley A.',
          country: 'United States',
          rating: 5,
          image: 'sm_ashley_a.jpg',
        },
        {
          text: 'This course is absolutely complete to make you an enviable staff with great skill in a typical finance and accounts department of any company. I always run back to it for refreshing my excel skills.',
          name: 'Daniel E.',
          country: 'United States',
          rating: 5,
          image: 'sm_daniel_e.jpg',
        },
        {
          text: 'Great course. This course has helped me a lot in gaining knowledge in finance, accounting, business analysis, advanced MS excel, and PowerPoint. Highly recommended.',
          name: 'Snehadri N.',
          country: 'Myanmar',
          rating: 4,
          image: 'sn.jpg',
        },
        {
          text: 'This an excellent course for anyone planning to pursue career in Finance domains, be it as an Analyst or Investment Banking. It explains all the concepts from very basics and has excellent notes in the course resources as well. The mentors even answer to the doubts in the QnA section, a rare thing to find on online mode of education.',
          name: 'Namita K.',
          country: 'India',
          rating: 5,
          image: 'nk.jpg',
        },
        {
          text: 'Excellent course for a novice. Some issues require a more extensive explanation since a newbie will find it difficult to grasp in a single sitting. Its jam-packed with useful information.',
          name: 'Aniket G.',
          country: 'Nepal',
          rating: 4,
          image: 'sm_aniket_g.jpg',
        },
        {
          text: 'This is the best course a student aspiring to become a financial analyst can ask for. It covers all the basics, many advanced topics, and on top of all of that contains plenty of real time case studies. Most of all this is very affordable.',
          name: 'Dinesh K.',
          country: 'Bangladesh',
          rating: 5,
          image: 'sm_dinesh_k.jpg',
        },
        {
          text: 'All the financial aspects such as excel, accounting and finance are closely integrated. And, I can sense this early that, this is going to be a beautiful learning journey for me.',
          name: 'Aryan R.',
          country: 'France',
          rating: 5,
          image: 'sm_aryan_r.jpg',
        },
        {
          text: 'This course is really good and each concept is explained very clearly. Quiz at the end of all sections is also helpful in a way to get our concepts and application of functions more crystal clear.',
          name: 'Ayasha A.',
          country: 'United States',
          rating: 5,
          image: 'sm_ayasha_a.jpg',
        },
        {
          text: 'Apart from learning excel and being a commerce student myself I never thought that accounting can be this interesting as Im not a number person. We were never given practical examples regarding all this at university as we have all the theoretical knowledge. Great Course',
          name: 'Kashish S.',
          country: 'Pakistan',
          rating: 5,
          image: 'ks.jpg',
        },
        {
          text: 'Really intuitive and engaging. Would highly recommend this course to graduates & working professionals who are looking for a deeper knowledge into financial analysis. Helps in honing your excel skills too!',
          name: 'Rajreet C.',
          country: 'India',
          rating: 5,
          image: 'rc.jpg',
        },
        {
          text: 'The course was very well structured and presented. The instructor broke down complex topics to a digestible and easy-to-understand manner. I especially enjoyed the tips & tricks information on the Microsoft Office tools as this was easily applicable in the real office world',
          name: 'Emmanuel M.',
          country: 'France',
          rating: 5,
          image: 'sm_emmanuel_m.jpg',
        },
        {
          text: 'I have enjoyed learning accounting/finance concepts in this course. The instructor provided easy to understand examples that helped me understand the topics.',
          name: 'Ashley B.',
          country: 'Hungary',
          rating: 4,
          image: 'sm_ashley_b.jpg',
        },
        {
          text: 'Ive learned so much about business, company, and accounting through just one course. Its for those who wants to learn about finance from basic to advance.',
          name: 'Srikant P.',
          country: 'India',
          rating: 5,
          image: 'sm_srikant_p.jpg',
        },
        {
          text: 'I really didn’t have a financial background or even so much knowledge about it and this course has open my panorama and vision of the subject. Its an easy and practical way to start yourself in this market.',
          name: 'Luis Eduardo González D.',
          country: 'Spain',
          rating: 5,
          image: 'sm_luis eduardo gonzález_d.jpg',
        },
        {
          text: 'I didnt know anything about Investment Banking when I started this course. The course is structured in a very interesting and engaging way, that makes it easy to understand, and easy to remember. I highly recommend taking it as I now have a brilliant understanding of the Banking world.',
          name: 'Kian P.',
          country: 'Germany',
          rating: 5,
          image: 'sm_kian_p.jpg',
        },
      ];
    },
    dataStructure() {
      const cols = this.$store.state.layout === 'desktop' || this.$store.state.tablet ? 3 : 1;
      const data = this.reviews();

      const chunkSize = Math.ceil(data.length / cols);
      const dataArray = [];
      for (let i = 0; i < data.length; i += 1) {
        const chunkIndex = Math.floor(i / chunkSize);

        if (!dataArray[chunkIndex]) {
          dataArray[chunkIndex] = [];
        }

        dataArray[chunkIndex].push(data[i]);
      }
      for (let i = 0; i < dataArray.length; i += 1) {
        dataArray[i] = [...dataArray[i]];
      }

      return dataArray;
    },
    expandReviews() {
      if (this.seeMore) {
        const anchor = this.uniqueClass ? this.uniqueClass : 'reviews-heading';
        const trustPilot = document.querySelector(`.${anchor}`);
        trustPilot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      this.seeMore = !this.seeMore;
    },
  },
};
</script>

<style lang="scss" scoped>
.reviews-trustpilot {
  &.dark {
    .reviews-heading > div {
      .heading {
        color: var(--main-light);
      }

      > div {
        color: var(--main-dark-shade-4);

        svg path[fill]:first-of-type {
          fill: var(--main-light);
        }
      }
    }

    .reviews-body {
      .card-trustpilot-review {
        background: var(--main-dark-shade-2);
      }

      .text {
        color: var(--main-dark-shade-4);
      }
    }

    .see-more:after {
      background: linear-gradient(360deg, var(--main-dark) 0%, rgba(2, 14, 33, 0.77) 42.76%, rgba(41, 51, 67, 0) 98%);
    }
  }

  .reviews-heading > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    .heading {
      font-size: 70px;
      font-weight: normal;
      margin: 0 var(--spacing-30) 0 0;
      text-align: center;

      &.title {
        max-width: 800px;
        margin: 0;
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: var(--main-dark-shade-3);

      svg {
        width: 175px;
        height: 43px;

        path[fill]:first-of-type {
          fill: #2F2F2F;
        }
      }
    }
  }

  .reviews-body {
    max-height: 850px;
    overflow: hidden;
    transition: all 800ms ease-in;

    &.short {
      max-height: 400px;
      transition-duration: var(--duration);
    }

    &.show {
      max-height: 2000px;
    }

    .card-trustpilot-review {
      padding: 25px;
      margin-bottom: var(--spacing-30);
      background: var(--main-light);
      box-shadow: 0 14px 30px rgba(0, 12, 31, 0.06);
      border-radius: 7px;

      .heading {
        display: flex;
        align-items: center;
        margin-bottom: var(--spacing-12);

        img {
          margin-right: 14px;
          border-radius: 50%;
          width: 42px;
        }
      }

      .rating {
        margin-bottom: var(--spacing-16);
        display: flex;

        .rating-star-wrapper {
          width: 20px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 1.66px;

          &.filled {
            background-color: #00B67A;
          }

          &.light {
            background-color: #73CF11;
          }

          &:not(.filled) {
            background-color: #DCDCE6;
          }
        }
      }

      .title {
        font-size: 14px;
        letter-spacing: 0.02em;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .text {
        font-size: 14px;
        letter-spacing: 0.02em;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
    }
  }

  .see-more {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 20px;
    color: var(--accent);
    margin-top: 10px;

    span {
      cursor: pointer;
      font-weight: 600;

      &:not(.expand) {
        svg {
          transform: rotate(180deg);
        }
      }

      svg {
        margin-left: 10px;

        path[fill] {
          fill: var(--accent);
        }
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: -120px;
      height: 120px;
      left: 0;
      right: 0;
      bottom: 20px;
      background: linear-gradient(360deg, var(--main-light-shade-1) 0%, var(--main-light-shade-1) 39.95%, rgba(250, 250, 251, 0) 108.02%);
    }

    &.expanded:after {
      height: 0;
    }
  }

  @include bp($bp-mobile) {
    .reviews-heading > div {
      flex-wrap: wrap;

      .heading {
        font-size: 46px;
        margin-right: 10px;

        &.title {
          font-size: 32px;
        }
      }

      > div {
        font-size: 14px;
      }
    }

    .reviews-body {
      &.short {
        max-height: 800px;
        transition-duration: 800ms;
      }

      &.show {
        max-height: 5500px;
      }

      .card-trustpilot-review {
        margin-bottom: var(--spacing-24);

        .heading {
          font-size: 14px;

          img {
            width: 42px;
            height: 42px;
          }
        }
      }

      .reviews-body-holder > div {
        padding: 0 15px;
      }
    }
  }
}
</style>
